import { constructEnum } from '@/lib/enum';

export default constructEnum('ThumbnailDisplayType', {
  ORIGINAL: 10,
  SQUARE: 20,
  VERTICAL: 30
});
